import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const VIEW_TYPES = [
  { value: "on_screen", label: "On Screen" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "excel_unformatted", label: "Excel (Unformatted)" },
  { value: "email", label: "Email" },
];

const PRODUCTS = [
  { value: "mutual_fund", label: "Mutual Fund" },
  { value: "share_bond", label: "Share & Bond" },
  { value: "fixed_deposit", label: "Fixed Deposit" },
  { value: "other_assets", label: "Other Assets" },
];

const COLUMN_OPTIONS = [
  "Purchase NAV",
  "Purchase Value",
  "Current NAV",
  "Balance Units",
  "Dividend",
  "Gain",
  "Holding Days",
  "Absolute Return",
  "CAGR",
];

export default function PortfolioValuation() {
  const [viewType, setViewType] = useState("on_screen");
  const [product, setProduct] = useState("mutual_fund");
  const [investor, setInvestor] = useState("all_selected");
  const [source, setSource] = useState("all");
  const [reportDate, setReportDate] = useState(() => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  });
  const [holdingPeriod, setHoldingPeriod] = useState("all");
  const [transactionType, setTransactionType] = useState("all_selected");
  const [advancedOpen, setAdvancedOpen] = useState(true);
  const [category, setCategory] = useState("all_selected");
  const [subCategory, setSubCategory] = useState("all_selected");
  const [fund, setFund] = useState("all_selected");
  const [folio, setFolio] = useState("all_selected");
  const [columns, setColumns] = useState(() =>
    COLUMN_OPTIONS.reduce((acc, col) => ({ ...acc, [col]: true }), {})
  );
  const [applying, setApplying] = useState(false);

  const toggleColumn = (name) => {
    setColumns((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 800);
    // TODO: call report API / show result based on viewType
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>

        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Portfolio Valuation</h3>
                <nav
                  aria-label="breadcrumb"
                  style={{ "--bs-breadcrumb-divider": "none" }}
                >
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/portfolio-valuation">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Portfolio Valuation</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>


        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
         
          {/* View Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              View Type:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {VIEW_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2 cursor-pointer" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="viewType"
                    value={opt.value}
                    checked={viewType === opt.value}
                    onChange={() => setViewType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Choose Product */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Choose Product:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {PRODUCTS.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="product"
                    value={opt.value}
                    checked={product === opt.value}
                    onChange={() => setProduct(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Filter */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "12px" }}>
              Filter:
            </label>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label small text-muted">Investor :</label>
                <select
                  className="form-select"
                  value={investor}
                  onChange={(e) => setInvestor(e.target.value)}
                  style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                >
                  <option value="all_selected">All Selected</option>
                  <option value="primary">Primary</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Source :</label>
                <select
                  className="form-select"
                  value={source}
                  onChange={(e) => setSource(e.target.value)}
                  style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                >
                  <option value="all">All</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Report as on date :</label>
                <input
                  type="date"
                  className="form-control"
                  value={reportDate}
                  onChange={(e) => setReportDate(e.target.value)}
                  style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Holding Period :</label>
                <select
                  className="form-select"
                  value={holdingPeriod}
                  onChange={(e) => setHoldingPeriod(e.target.value)}
                  style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                >
                  <option value="all">All</option>
                  <option value="stcg">STCG</option>
                  <option value="ltcg">LTCG</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Transaction Type :</label>
                <select
                  className="form-select"
                  value={transactionType}
                  onChange={(e) => setTransactionType(e.target.value)}
                  style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                >
                  <option value="all_selected">All Selected</option>
                </select>
              </div>
            </div>
          </div>

          {/* Advanced Filters */}
          <div className="mb-4">
            <button
              type="button"
              onClick={() => setAdvancedOpen(!advancedOpen)}
              className="btn btn-primary"
            >
              <i className={`fa fa-chevron-${advancedOpen ? "up" : "down"}`} />
              Advanced Filters
            </button>
            {advancedOpen && (
              <div className="row g-3 mt-2 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                <div className="col-md-3">
                  <label className="form-label small text-muted">Category :</label>
                  <select
                    className="form-select"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                  >
                    <option value="all_selected">All Selected</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">Sub Category :</label>
                  <select
                    className="form-select"
                    value={subCategory}
                    onChange={(e) => setSubCategory(e.target.value)}
                    style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                  >
                    <option value="all_selected">All Selected</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">Fund :</label>
                  <select
                    className="form-select"
                    value={fund}
                    onChange={(e) => setFund(e.target.value)}
                    style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                  >
                    <option value="all_selected">All Selected</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">Folio :</label>
                  <select
                    className="form-select"
                    value={folio}
                    onChange={(e) => setFolio(e.target.value)}
                    style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                  >
                    <option value="all_selected">All Selected</option>
                  </select>
                </div>
              </div>
            )}
          </div>

          {/* Columns Include */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Columns Include:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {COLUMN_OPTIONS.map((col) => (
                <label key={col} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={columns[col]}
                    onChange={() => toggleColumn(col)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "14px", color: "#475569" }}>{col}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Apply */}
          <div className="d-flex justify-content-center pt-2">
            <button
              type="button"
              className="btn btn-lg px-5"
              onClick={handleApply}
              disabled={applying}
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              {applying ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Applying...
                </>
              ) : (
                "Apply"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
